<template>
  <div class="app-admin-wrap layout-sidebar-large">
    <Header />
    <sidebar />
    <!-- =============== Left side End ================-->
    <div class="main-content-wrap sidenav-open d-flex flex-column">
        <!-- ============ Body content start ============= -->
        <div class="main-content">
          <router-view></router-view>
       <!-- end of main-content -->
        </div><!-- Footer Start -->
        <div class="flex-grow-1"></div>
       <Footer />
        <!-- fotter end -->
    </div>
</div>
</template>

<script>
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import upperHeader from "../layouts/upperheader";
import Footer from "../layouts/footer";

export default {
  components: {
    Header,
    Sidebar,
    upperHeader,
    Footer
  }
};
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue